export default "__VITE_ASSET__3b1d69b2__"